import { render } from "./QCChartResult.vue?vue&type=template&id=663c173b"
import script from "./QCChartResult.vue?vue&type=script&lang=js"
export * from "./QCChartResult.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/QCCharts/QCChartResult.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "663c173b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('663c173b', __exports__)) {
    console.log('reload')
    api.reload('663c173b', __exports__)
  }
  
  module.hot.accept("./QCChartResult.vue?vue&type=template&id=663c173b", () => {
    console.log('re-render')
    api.rerender('663c173b', render)
  })

}


export default __exports__